import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CheckCircle as OkIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import Header from '../../Header/Header';
import YesNoDialog from '../../YesNoDialog';
import InformationDialog from '../../InformationDialog';
import { fetchNewPropo, newNpropValue, fetchDevis } from "../../../redux/actions/devisActions";
import GenPdf from '../../GenPdf';
import NumDoss from '../../NumDoss';
import history from '../../Routes/history';
import Dialogs from './Dialogs/Dialogs';
import { getNumValidation, getValidation, numberNprop, getDevisPaymentMethod } from '../Utils';

class DevisValidation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ht: "",
      tva: "",
      ttc: "",
      file: null,
      isOpen: false,
      openDialog: false,
      validation: false,
      numValidation: 0,
      openDialogNprop: false,
      openDialogValidate: false,
      openDialogDelete: false,
      openDialogDeleteInfo: false,
      messageDeleteInfo: "",
      maxNprop: 0
    };
  }

  componentDidMount() {
    const { deviscon, dossierValue, nprop } = this.props;
    if (getValidation(deviscon, dossierValue, nprop)) {
      const updateNumValidation = getNumValidation(deviscon, dossierValue);
      this.setState({ validation: true, numValidation: updateNumValidation });
    }
    if (dossierValue && deviscon) {
      this.setState({ maxNprop: numberNprop(deviscon, dossierValue) });
    }
  }

  componentDidUpdate(prevProps) {
    const { deviscon, dossierValue, nprop } = this.props;
    if (this.props.dossierValue !== prevProps.dossierValue || nprop !== prevProps.nprop || JSON.stringify(deviscon) !== JSON.stringify(prevProps.deviscon)) {
      const updateValidation = getValidation(deviscon, dossierValue, nprop);
      const updateNumValidation = getNumValidation(deviscon, dossierValue);
      this.setState({ validation: updateValidation, numValidation: updateNumValidation, maxNprop: numberNprop(deviscon, dossierValue) });
    }
  }

  async handleAffDevis() {
    this.setState({ file: null });
    let response = await this.getFile('pdf');

    if (response.blob.size > 100) {
      this.setState({ file: response.blob });
      this.openDoc();
    }
  }

  verifyValid() {
    if (this.state.validation || this.state.numValidation >= 3) {
      return true;
    }
    return false;
  }

  async handleClickValidate() {
    const { dossierValue, nprop } = this.props;

    const body = {
      ndossier: dossierValue,
      nprop
    };

    await fetch("/api/devis/validerDevis", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    await this.props.dispatch(fetchNewPropo(dossierValue));
    await this.props.dispatch(newNpropValue(nprop));
    await this.handleCloseValidate();
  }

  async handleDeleteDevis() {
    const { deviscon, dossierValue, nprop } = this.props;

    const devisFiltred = deviscon.filter(item => item.ndossier === dossierValue);
    const maxNprop = Math.max(...devisFiltred.map(item => item.nprop));

    if (nprop === 1) {
      this.setState({ messageDeleteInfo: "Vous ne pouvez pas supprimer le premier devis", openDialogDelete: false, openDialogDeleteInfo: true });
      return;
    } else if (nprop !== maxNprop) {
      this.setState({ messageDeleteInfo: `Vous ne pouvez pas supprimer cette proposition, car il existe une proposition plus récente N° ${maxNprop}`, openDialogDelete: false, openDialogDeleteInfo: true });
      return;
    }

    try {
      await fetch(`/api/devis/deleteDevis/${dossierValue}/${nprop}`, { method: 'DELETE' });
      await this.props.dispatch(fetchDevis());
      await this.props.dispatch(fetchNewPropo(dossierValue));
    } catch (error) {
      console.error(error);
    } finally {
      this.handleCloseDelete();
    }
  }

  async handleNewPropo() {
    const { dossierValue } = this.props;
    const { maxNprop } = this.state;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ ndossier: dossierValue })
    };

    try {
      const response = await fetch("/api/devis/createNewPropo", requestOptions);
      const result = await response.json();

      if (result === true) {
        await this.props.dispatch(fetchNewPropo(dossierValue));
        await history.push("/devis/conception");
        await this.props.dispatch(newNpropValue(maxNprop + 1));
      } else {
        this.setState({ openDialogNprop: true });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getFile(type) {
    try {
      const res = await fetch("/api/devis/getDevisValid", {
        method: "POST",
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ndossier: this.props.dossierValue, nprop: this.props.nprop, type })
      });
      const blob = await res.blob();
      const fileName = res.headers.get('X-FileName');
      return { blob, fileName };
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  openDoc() {
    this.setState({ isOpen: true });
  }

  closeDoc() {
    this.setState({ isOpen: false });
  }

  clickToModif() {
    this.setState({ openDialog: true });
  }

  closeDialog() {
    this.setState({ openDialog: false });
  }

  handleCloseNprop = () => {
    this.setState({ openDialogNprop: false });
  };

  handleCloseValidate = () => {
    this.setState({ openDialogValidate: false });
  };

  handleOpenValidate = () => {
    this.setState({ openDialogValidate: true });
  };

  handleCloseDelete = () => {
    this.setState({ openDialogDelete: false });
  };

  handleOpenDelete = () => {
    this.setState({ openDialogDelete: true });
  };

  render() {
    return (
      <div className="devisValid">
        <Header />
        <NumDoss type="devis" />

        <h1 className="title">Validation de devis</h1>
        <div className="buttons">
          <Button
            variant="contained"
            color="primary"
            startIcon={<VisibilityIcon />}
            onClick={this.handleAffDevis.bind(this)}
          >
            Afficher
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<OkIcon />}
            onClick={this.handleOpenValidate}
            disabled={this.verifyValid()}
          >
            Valider
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={this.clickToModif.bind(this)}
            disabled={!this.state.validation}
          >
            Modifier
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={() => this.setState({ openDialogDelete: true })}
            style={{ backgroundColor: this.props.nprop ? "red" : "" }}
            disabled={!this.props.nprop}
          >
            Supprimer
          </Button>
        </div>
        <GenPdf isOpen={this.state.isOpen} file={this.state.file} closeDoc={this.closeDoc.bind(this)} scale={this.state.file !== null ? 1.5 : 0.5} />
        {this.state.openDialog && <Dialogs closeDialog={this.closeDialog.bind(this)} />}

        <Dialog open={this.state.openDialogNprop} onClose={this.handleCloseNprop}>
          <DialogTitle>INFORMATION</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Vous ne pouvez pas créer plus de 3 nouvelles propositions après avoir valider un devis
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.handleCloseNprop} style={{ color: "white", backgroundColor: "#FF7F50" }}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <YesNoDialog
          isOpen={this.state.openDialogValidate}
          title={"VALIDATION DEVIS"}
          question={`Êtes-vous sûr de vouloir valider la proposition N°${this.props.nprop} du dossier N°${this.props.dossierValue} ?`}
          handleYesClick={this.handleClickValidate.bind(this)}
          handleClose={this.handleCloseValidate}
        />

        <YesNoDialog
          isOpen={this.state.openDialogDelete}
          title={"SUPPRESSION DEVIS"}
          question={`Êtes-vous sûr de vouloir supprimer la proposition N°${this.props.nprop} du dossier N°${this.props.dossierValue} ?`}
          handleYesClick={this.handleDeleteDevis.bind(this)}
          handleClose={this.handleCloseDelete}
        />

        <InformationDialog
          isOpen={this.state.openDialogDeleteInfo}
          title={'INFORMATION'}
          information={this.state.messageDeleteInfo}
          handleClose={() => this.setState({ openDialogDeleteInfo: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  devisrea: state.devis.devisrea,
  deviscon: state.devis.deviscon,
  dossierValue: state.devis.dossierValue,
  nprop: state.devis.nprop,
  attachment: state.email.file,
  facture: state.facture.items
});

export default connect(mapStateToProps)(DevisValidation);
